/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Shortcuts} from "../Shortcuts.js";


class DetectOutsideClick extends PureComponent {

    constructor() {
        super();

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.shortcuts = new Shortcuts()

    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside, true);
        document.addEventListener("touchstart", this.handleClickOutside, true);

        this.shortcuts.register("Exit", "General", ['esc'], (event) => {
            if (this.props.isOpen && this.props.onOutsideClick !== undefined) {
                event.preventDefault()
                event.stopPropagation()
                this.props.onOutsideClick()
            }
        })

    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside, true);
        document.removeEventListener("touchstart", this.handleClickOutside, true);
        this.shortcuts.unmount()
    }


    handleClickOutside(event) {
        let onAdditionalRef = this.props.additionalRef ? this.props.additionalRef.current.contains(event.target) : false
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && !onAdditionalRef && (this.lastTarget !== event.target)) {
            if (this.props.onOutsideClick !== undefined) {
                this.props.onOutsideClick()
            }

        }
    }

    render() {
        return <div className={this.props.className} style={this.props.style}
                    onMouseDown={(event) => {
                        this.lastTarget = event.target
                    }}
                    ref={this.wrapperRef}>{this.props.children}</div>;
    }
}

DetectOutsideClick.propTypes = {
    onOutsideClick: PropTypes.func,
    additionalRef: PropTypes.any,
    className: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.array,
    ])
};

DetectOutsideClick.defaultProps = {
    className: "",
    style: {}
}

export default DetectOutsideClick;